import { cn } from '@yeshuman/sdk'
import { Info } from 'lucide-react'

/**
 * Assistive-not-diagnostic disclaimer for health surfaces (conditions,
 * reports). Keeps the regulatory copy in one place.
 */
export function HealthDisclaimer({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-md border bg-muted/50 px-3 py-2 text-sm text-muted-foreground',
        className,
      )}
      role="note"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <p>
        This is a self-management record, not medical advice. Lumie doesn't diagnose conditions or
        make treatment decisions — talk to a qualified practitioner about diagnosis and treatment.
      </p>
    </div>
  )
}
